import React from 'react';

export default {
  width: 30,
  height: 17,
  content: (
    <path d="M27.3121 9.18457H.469727v-2H27.3121v2zM27.0208 8.21759l-6.5105-6.51041L21.9246.292969l7.9246 7.924621-7.9246 7.92461-1.4143-1.4142 6.5105-6.51041z" />
  )
};
